module.exports = __webpack_public_path__ + "img/yöpymislaavu_original.f5ea3c4a.jpg";